import React        from 'react';
import { isServer } from '../../../utils';
import classNames from 'classnames';
import styles from './AdBlock.css';

type AdMockBaseProps = {
    id: string;
    size: string;
};

type ContainerProps = {
    width: number;
    height: number;
};

export class AdBlock extends React.Component<AdMockBaseProps> {
    shouldComponentUpdate() {
        return false;
    }

    componentDidMount() {
        if (!isServer) {
            const {id, size} = this.props;
            if (typeof (window as any).aarpegpt === 'undefined') {
                (window as any).AARP.Everywhere.failedLoadAdCalls.push({
                    container: null,
                    id,
                    adSize: size,
                });
            } else {
                (window as any).aarpegpt.loadAd(null, id, size);
            }
        }
    }

    render() {
        const {id} = this.props;

        return (
            <Container
                className = "aarpe-ad"
                data-element-description = "ad block"
                aria-hidden = "true"
                id = {id}
            />
        );
    }
}

const Container = (props: any) => <div {...props} className = {classNames(styles.container, props.className)} />;
